import React from "react";
import LinkList from "../../Pages/LinkList";

const TermsAndConditionsDetails = () => {
  return (
    <>
    <LinkList />
    <div className="py-5 bg-white">
      <div className="container">
        <h5 className=" fs_24 fw-bold ff_helvetica">Seller Agreement Form</h5>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-5">
          The Platform operates an online marketplace for the sale of various
          goods and services.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          The Seller desires to sell its products and services on the Platform.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0 mt-4">
          Now, Therefore, In Consideration Of The Mutual Promises And Covenants
          Contained Herein, The Parties Agree As Follows:
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          1. Registration and Use of Platform:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          1.1. The Seller agrees to register as a seller on the Platform in
          accordance with the registration process specified by the Platform.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          1.2. By registering on the Platform, the Seller agrees to abide by the
          terms and conditions set forth in this Agreement and any other
          policies or guidelines provided by the Platform.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          2. Listing of Products and Services:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          2.1. The Platform agrees to enable the Seller to list its goods and
          services for sale on the Platform, subject to the terms of use,
          privacy policy, and other applicable policies of the Platform.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          2.2. The Platform shall provide the Seller with access to its seller
          dashboard for the purpose of facilitating the listing of products and
          services.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          3. Fees and Charges:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          3.1. The Seller agrees to pay the Platform a commission fee for each
          product or service sold through the Platform, in accordance with the
          fee structure specified by the Platform.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          3.2. The commission fee shall be deducted from the proceeds of each
          sale made by the Seller on the Platform.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          4. Promotional Content:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          4.1. The Seller agrees that the Platform may prepare and produce
          promotional materials or content, which may incorporate the Seller's
          trademarks, logos, and product images, for the purpose of promoting
          the Platform and the Seller's products and services.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          4.2. The Platform agrees to exercise due care and diligence in
          preparing and producing promotional materials or content, and shall
          ensure that such materials do not harm the reputation and goodwill of
          the Seller.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          5. Intellectual Property:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          5.1. Each party shall retain ownership of its respective intellectual
          property rights.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          5.2. The Platform is granted a non-exclusive, worldwide, royalty-free
          license to use the Seller's trademarks, logos, and other branding
          materials solely for the purpose of promoting the Seller's products
          and services on the Platform.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          6. Data Protection and Privacy:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          6.1. The Platform shall adopt policies to comply with applicable data
          protection and privacy laws, and the Seller agrees to comply with such
          policies.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          6.2. The Platform shall process any personal data obtained from the
          Seller in accordance with its privacy policy.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          7. Liability and Indemnification:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          7.1. The Seller agrees to indemnify and hold the Platform harmless
          from any claims, damages, losses, liabilities, costs, and expenses
          arising out of or in connection with the Seller's products, services,
          or breach of this Agreement.
        </p>

        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">
          8. Confidentiality:
        </h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          8.1. Both parties agree to keep confidential any proprietary or
          confidential information disclosed by the other party during the term
          of this Agreement and thereafter.
        </p>

        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">9. Termination:</h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          9.1. This Agreement shall commence upon the Seller's acceptance of the
          terms and conditions and shall continue until terminated by either
          party with a notice period specified in the Platform's policies.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          9.2. The Platform reserves the right to terminate the Seller's access
          to the Platform at any time for any reason, including but not limited
          to violation of this Agreement or the Platform's policies.
        </p>
        <h6 className=" ff_helvetica fs_18 fw-bold mt-4">10. Miscellaneous:</h6>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mt-4">
          10.1. This Agreement constitutes the entire understanding and
          agreement between the parties with respect to the subject matter
          herein and supersedes all prior agreements and understandings, whether
          written or oral.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          10.2. This Agreement may be amended or modified only by a written
          instrument signed by both parties.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0">
          10.3. If any provision of this Agreement is held to be invalid or
          unenforceable, the remaining provisions shall remain in full force and
          effect.
        </p>
        <p className="mb-0 fs_15 ff_inter color_darkgray_4 mb-0 mt-5">
          By registering as a seller on the Platform, you acknowledge that you
          have read, understood, and agree to be bound by the terms and
          conditions of this Agreement.
        </p>
      </div>
    </div>
    </>
  );
};

export default TermsAndConditionsDetails;
